import { StackScreenProps } from "@react-navigation/stack";
import {
  FlatActionList,
  ModalCloseButton,
  Page,
} from "@towersystems/roam-common-native";
import { useEffect } from "react";
import { RegisterRootParamList } from "../../../../types";
import { useAddItem } from "../../utils/sale-controller";
import { useVariantPicker } from "../../utils/variant-picker/use-variant-picker";
import Product from "../../../../utilities/data/model/Product";

export type VariantPickerModalScreenProps = StackScreenProps<
  RegisterRootParamList,
  "VariantPickerModalScreen"
>;

export const VariantPickerModalScreen = ({
  navigation,
  route,
}: VariantPickerModalScreenProps) => {
  const { productId } = route.params;
  const addItem = useAddItem({ navigation });

  function handleProductSelected(product: Product) {
    if (product.serialNumbersSale) {
      navigation.goBack();
      navigation.navigate("SerialNumberRootScreen", {
        screen: "ListProductSerialNumbersScreen",
        params: {
          productId: product.id,
        },
      });
    } else {
      addItem(product.id, { skipVariantPicker: true })
        .then(() => {
          navigation.goBack();
        })
        .catch((e) => console.log(e));
    }
  }

  const { beginVariantPicker, items, state, actions } = useVariantPicker({
    onProductSelected: handleProductSelected,
  });

  const { product, activeOption, activeOptionIndex, selectedOptionValues } =
    state;

  const { clearOptionValueAfterIndex } = actions;

  useEffect(() => {
    if (product && activeOption) {
      navigation.setOptions({
        title:
          selectedOptionValues.length >= 1
            ? `${selectedOptionValues.join(" / ")} / Select ${
                activeOption.name
              }`
            : `Select ${activeOption.name}`,
        headerLeft: () => {
          if (activeOptionIndex <= 0) {
            return <ModalCloseButton />;
          } else {
            return (
              <ModalCloseButton
                type="Back"
                onPress={() => {
                  clearOptionValueAfterIndex(activeOptionIndex - 1);
                }}
              />
            );
          }
        },
      });
    }
  }, [product?.id, activeOption, activeOptionIndex]);

  useEffect(() => {
    beginVariantPicker(productId);
  }, [productId]);

  return (
    <Page>
      <FlatActionList items={items} />
    </Page>
  );
};
